import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'

const GTM_CONTAINER_ID = 'GTM-P4Z7NBVZ'

/**
 * Analytics instance wired to Google Tag Manager.
 * Initializing this injects the GTM gtm.js script (the "head code") and sets up
 * the dataLayer, so page views and events flow through the GTM container.
 */
export const analytics = Analytics({
  app: 'brightwood-club',
  plugins: [
    googleTagManager({
      containerId: GTM_CONTAINER_ID,
    }),
  ],
})

export { GTM_CONTAINER_ID }
